import _ from 'lodash';

const processStrategy = (message) => {
  const relations = {};
  const omit = [];
  return { ..._.omit(message, omit), ..._.pickBy(relations, _.identity) };
};

export default {
  key: 'message',
  definition: {},
  processStrategy,
};
